import styled from 'styled-components'

export const Image = styled.img`
    ${ props => props.border ? `
        border: 1rem solid ${ props.theme.colors.main };
        border-radius: 50%;
    ` : '' }

    @media print {
        max-width: 100%;
        height: auto;

        ${ props => props.border ? `
            border: none;
            border-radius: 0.5rem;
        ` : '' }
    }
`
